import { wrapGql } from "../_"

export default (a: NuxtAxiosInstance) => ({
  downloadInvitationDocument: () => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation {
          downloadInvitationDocument
        }
      `,
    }, {
      responseType: "blob",
    }),
    "downloadInvitationDocument",
    true,
  ),

  downloadVisaInvitationDocument: () => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation {
          downloadVisaInvitationDocument
        }
      `,
    }, {
      responseType: "blob",
    }),
    "downloadVisaInvitationDocument",
    true,
  ),

  downloadVoucher: () => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query {
          downloadVoucher
        }
      `,
    }, {
      responseType: "blob",
    }),
    "downloadVoucher",
    true,
  ),

  downloadCertificate: () => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query {
          downloadCertificate
        }
      `,
    }, {
      responseType: "blob",
    }),
    "downloadCertificate",
    true,
  ),

  downloadRegionalProgramCertificate: () => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query {
          downloadRegionalProgramCertificate
        }
      `,
    }, {
      responseType: "blob",
    }),
    "downloadRegionalProgramCertificate",
    true,
  ),

  downloadVolunteerCertificate: () => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query {
          downloadVolunteerCertificate
        }
      `,
    }, {
      responseType: "blob",
    }),
    "downloadVolunteerCertificate",
    true,
  ),

  downloadBloggerCertificate: () => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query {
          downloadBloggerCertificate
        }
      `,
    }, {
      responseType: "blob",
    }),
    "downloadBloggerCertificate",
    true,
  ),

  listDocumentGroup: () => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query {
          listDocumentGroup(limit: 999) {
            items {
              id
              title {
                current
              }
              documentsCount
            }
          }
        }
      `,
    }),
  ),

  listDocument: (filters: any) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query ($filters: [Filter]) {
          listDocument(filters: $filters limit: 999) {
            items {
              id
              creationTime
              lastRevisionTime
              title {
                current
              }
              documentRu {
                url
              }
              documentEn {
                url
              }
              group {
                id
              }
            }
          }
        }
      `,
      variables: {
        filters,
      },
    }),
  ),
})
